<template>
  <ModalComponent
    :model-value="showRef"
    :close="handleCloseModal"
    :max-width="50"
    :off-event="offEvent"
    :style-class="classModal"
    :style-class-contain="styleClassContain"
    :class-name="`tw-z-[1071]`"
  >
    <ModalHeader
      is-header=""
      style="z-index: 10"
      :title="
        getComponentUiText(
          'app-settings-team-members-modal-mfa-selection-title-1',
        )
      "
      @close="handleCloseModal"
    />
    <mfaSelectionContent
      :multiple-options="multipleOptions"
      @update:click:authen="handleByAuthen"
      @update:click:passkey="handleByPasskey"
    >
    </mfaSelectionContent>
  </ModalComponent>
</template>

<script setup lang="ts">
import ModalHeader from "@/components/common/modalHeader.vue";
import { ref, watch } from "vue";
import ModalComponent from "@/components/common/modalComponent.vue";
import { getComponentUiText } from "@/utils/utilities";
import store from "@/store";
import { MFAStatus, MODAL_NAME } from "@/utils/constants";
import { onMounted } from "vue";
import { startRegistration } from "@simplewebauthn/browser";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import userService from "@/services/user/userService";
import { successStatusCodes } from "@/utils/constants";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import mfaSelectionContent from "@/components/user/mfaSelectionContent.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { UserRoute } from "@/services/apiRoutes/routes";

const props = defineProps({
  show: {
    type: Boolean,
    required: false,
  },
  profileData: {
    type: Object as () => any,
    default: () => {},
  },
  offEvent: {
    type: Boolean,
    default: false,
  },
  isInternal: {
    type: Boolean,
    required: false,
  },
});

const multipleOptions = ref(true);

let showRef = ref(props.show);

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);

onMounted(() => {
  if (
    props.profileData.mfaEnabled === MFAStatus.REGISTERED ||
    props.profileData.mfaEnabled === MFAStatus.REGISTERED_PK
  ) {
    multipleOptions.value = false;
  } else {
    multipleOptions.value = true;
  }
});

watch(
  () => props.profileData,
  (value) => {
    if (
      value.mfaEnabled === MFAStatus.REGISTERED ||
      value.mfaEnabled === MFAStatus.REGISTERED_PK
    ) {
      multipleOptions.value = false;
    } else {
      multipleOptions.value = true;
    }
  },
);

const emit = defineEmits(["update:show", "update:close"]);
const handleCloseModal = () => {
  store.commit("User/setIsCloseModalProfile", true);
  showRef.value = false;
  emit("update:show", showRef.value);
  emit("update:close");
};

const handleByPasskey = () => {
  userService.mfaWebauthnRegister().then(async (res: any) => {
    try {
      const challengeResponse = res.data.data;
      const attResp = await startRegistration(challengeResponse);
      userService
        .mfaWebauthnVerifyRegister(attResp)
        .then(async (res: any) => {
          const message = getComponentUiText(
            "app-settings-add-mfa-success-message-1",
            false,
          );
          const emitData: IToastMessage = {
            variant: ToastVariant.SUCCESS,
            message,
          };
          EventEmitter.emit(
            EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE,
            emitData,
          );
        })
        .then(() => {
          EventEmitter.emit(EmitterEvents.RELOAD_CURRENT_USER_MEMBERSHIPS);
          EventEmitter.emit(EmitterEvents.RELOAD_MANAGE_MEMBERSHIPS, true);
          handleCloseModal();
        });
    } catch (err) {
      showErrorAPI(err, UserRoute.mfaWebauthnRegister);
    }
  });
};

const handleByAuthen = async () => {
  try {
    const res: any = await userService.getMFASetupInfo();
    if (res.status === successStatusCodes.OK) {
      showRef.value = false;
      emit("update:show", showRef.value);
      const emitData = {
        component: MODAL_NAME.MFA_ADD_TOTP_MODAL,
        properties: {
          profileData: {
            ...res.data.data,
            isInternal: props.isInternal,
            profileData: props.profileData,
          },
        },
        events: {},
      };
      if (emitData.component) {
        EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
      }
    }
  } catch (error: any) {
    showError({
      message: error?.data?.error?.message,
    });
  }
};
const showError = (message) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.ERROR,
    message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};
const classModal = {
  background: "rgb(0, 0, 0, 0.5)",
  "border-radius": "6px",
};

const styleClassContain = {
  "border-radius": "6px",
  "box-shadow": "0px 0px 4px 0px rgba(0, 0, 0, 0.05)",
};
</script>

<style lang="scss" scoped>
.select_option {
  border-radius: 4px;
  border: 1px solid var(--UI-light-sky-soft, #e4f1ff);
  font-family: Poppins;
}
</style>
